/*
 Pause for the autoplaying Swiper slideshows (snippets/slideshow-pause.liquid), without a visible
 button: a tap or click on the slideshow toggles it, keyboard focus inside holds it, and a
 focus-revealed button covers keyboard and screen reader users.

 Usage, once the Swiper exists: window.OhSnapSlideshowPause(swiper, root)
*/
(function () {
    if (window.OhSnapSlideshowPause) return;

    // A tap on any of these does its own job, not pause
    const OWN_CONTROL = "a[href], button, input, select, textarea, label, summary, video[controls], [role='button'], " +
        ".swiper-pagination-bullet, .swiper-button-prev, .swiper-button-next";

    window.OhSnapSlideshowPause = function (swiper, root) {
        const autoplay = swiper && swiper.autoplay;
        const toggle = root && root.querySelector("[data-slideshow-pause]");
        // Reduced motion leaves autoplay off: nothing moves, so there is nothing to pause
        if (!autoplay || !toggle || !swiper.params.autoplay || !swiper.params.autoplay.enabled) return;

        let held = false;   // paused while keyboard focus is inside

        function sync() {
            toggle.textContent = autoplay.running ? toggle.dataset.labelPause : toggle.dataset.labelPlay;
        }

        function flip() {
            if (autoplay.running) {
                autoplay.stop();
            } else {
                held = false;
                autoplay.start();
            }
        }

        toggle.hidden = false;
        sync();
        swiper.on("autoplayStart autoplayStop", sync);

        toggle.addEventListener("click", function () {
            flip();
            // Focus is still on the button, so a restart waits for focus to leave the slideshow
            if (autoplay.running) {
                autoplay.pause();
                held = true;
            }
        });

        /*
         A native listener, not Swiper's "click" event: that one only sees taps on the slide track,
         and misses the strip the bullets sit in. The click that ends a drag never gets here: Swiper
         stops it in the capture phase, and allowClick is false until the next touch.
        */
        swiper.el.addEventListener("click", function (event) {
            if (!swiper.allowClick || event.target.closest(OWN_CONTROL)) return;
            flip();
        });

        root.addEventListener("focusin", function () {
            if (autoplay.running && !autoplay.paused) {
                autoplay.pause();
                held = true;
            }
        });

        root.addEventListener("focusout", function (event) {
            if (root.contains(event.relatedTarget)) return;
            if (held && autoplay.running) autoplay.resume();
            held = false;
        });
    };
})();
